/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Even_Pig_RippleInputs */

const fr_fresh_even_pig_ripple = /** @type {(inputs: Fresh_Even_Pig_RippleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion`)
};

/**

* @param {Fresh_Even_Pig_RippleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fresh_even_pig_ripple = /** @type {((inputs?: Fresh_Even_Pig_RippleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Even_Pig_RippleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fresh_even_pig_ripple(inputs)
});